import { Routes } from '@angular/router';
import { ReportComponent } from './components/report/report.component';
import { CallBackComponent } from './components/admin/cb/cb.component';
import { AccessDeniedComponent } from "./components/report/access.denied.component";
import { CompareComponent } from './components/compare/compare-reports/compare.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CompareSelectComponent } from './components/compare/compare-select/compare-select.component';
import { EvaluatorAuthGuard } from './services/auth/evaluator/evaluatorAuthGuard.service';
import { AdminAuthGuard } from './services/auth/admin/adminAuthGuard.service';
import { UploadComponent } from './components/upload/upload.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AdminAuthGuard]
  },
  {
    path: 'dashboard/:studentId',
    component: DashboardComponent,
    canActivate: [AdminAuthGuard]
  },
  {
    path: ':role/dashboard',
    component: DashboardComponent,
  },
  {
    path: ':role/dashboard/:studentId',
    component: DashboardComponent,
  },
  {
    path: 'scan/:scanId',
    component: ReportComponent,
  },
  {
    path: ':role/scan/:scanId',
    component: ReportComponent,
  },
  {
    path: 'upload',
    component: UploadComponent,
    canActivate: [AdminAuthGuard]
  },
  {
    path: 'upload/:studentId',
    redirectTo: 'upload',
    pathMatch: 'full'
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'cb',
    component: CallBackComponent,
  },
  {
    path: 'compare/:studentId/:attachmentId',
    component: CompareSelectComponent,
    canActivate: [EvaluatorAuthGuard]
  },
  {
    path: 'compare/:attachment1/to/:attachment2',
    component: CompareComponent,
    canActivate: [EvaluatorAuthGuard]
  }
];
